module.exports = __webpack_public_path__ + "img/UTEDGE-1.309cbd55.jpg";